// extracted by mini-css-extract-plugin
module.exports = {"Ratio":"Ratio_Ratio__3vJPH","Overlay":"Ratio_Overlay__3TFCU","Content":"Ratio_Content__1ybAD","ContentItem":"Ratio_ContentItem__3IxjA"};